import * as React from "react";
import { inject, observer } from "mobx-react";
import FilterItem from "./FilterItem";
import { AppProps } from "../../stores/storeContract";
import "./Filter.scss";

@inject("filterStore")
@observer
export default class Filter extends React.Component<AppProps> {
    
	render() {

		const { addFilter, filters, openFilterId } = this.props.filterStore;

		return (
			<div className="filter">
				{
					filters.map((f, index) => {
						var filterItemProps = {
							filter: f,
							filterIndex: index + 1, //1-based index
							isOpen: openFilterId == f.id,
							...this.props
						};

						return (
							<FilterItem key={f.id} {...filterItemProps} />
						);
					})
				}
				<button className="btn btn-outline-success btn-sm header-btn btn-no-event-outline" onClick={addFilter}>
					<i className="fas fa-plus"></i> Add filter
				</button>
			</div>
		);
	}
}